import type { Marker as GoogleMapsClustererMarker } from '@googlemaps/markerclusterer'
import {
  ActiveMarker,
} from '@/scopes/common/components/Markers/ActiveMarker'
import { AdvancedMarker } from '@vis.gl/react-google-maps'
import * as React from 'react'

type SetMarkerClusterRef = (marker: GoogleMapsClustererMarker | null, key: string) => void

export interface MarkerProps {
  lat: number
  lng: number
  color: string
  id?: string
  onClick?: () => void
  setMarkerClusterRef?: SetMarkerClusterRef
}

export function Marker({ setMarkerClusterRef, ...props }: MarkerProps) {
  if (setMarkerClusterRef) {
    return (
      <ClusteredMarker
        {...props}
        setMarkerClusterRef={setMarkerClusterRef}
      />
    )
  }

  const { lat, lng, color, onClick } = props
  return (
    <AdvancedMarker position={{ lat, lng }} onClick={onClick}>
      <ActiveMarker color={color} />
    </AdvancedMarker>
  )
}

type ClusteredMarkerProps = Omit<MarkerProps, 'setMarkerClusterRef'> & {
  setMarkerClusterRef: SetMarkerClusterRef
}

function ClusteredMarker({ id, lat, lng, color, setMarkerClusterRef, ...props }: ClusteredMarkerProps) {
  const key = id ?? `${lat}${lng}`

  const ref = React.useCallback((marker: google.maps.marker.AdvancedMarkerElement | null) => {
    setMarkerClusterRef(marker, key)
  }, [
    setMarkerClusterRef,
    key,
  ])

  return (
    <AdvancedMarker
      ref={ref}
      position={{ lat, lng }}
      {...props}
    >
      <ActiveMarker color={color} />
    </AdvancedMarker>
  )
}
